/**
 * AUTO-GENERATED by packages/ui/scripts/generate-tokens.ts - do not edit by hand.
 * Regenerate: pnpm --filter @sosocio/ui run generate-tokens
 * Verify committed output is current: pnpm --filter @sosocio/ui run generate-tokens -- --check
 *
 * Derived from src/css/tailwind.css's @theme/@utility declarations (and, for
 * icon sizes only, packages/design-system/css/variables/defaults/foundations.css,
 * since tailwind.css exposes icon-size-* as an unenumerated wildcard utility).
 */

export const SEMANTIC_COLORS = [
	'brand-primary',
	'brand-primary-hover',
	'brand-primary-pressed',
	'brand-primary-disabled',
	'brand-primary-focus',
	'brand-primary-selected',
	'brand-primary-subtle',
	'brand-primary-muted',
	'brand-on-primary',
	'accent-default',
	'accent-subtle',
	'accent-strong',
	'text-default',
	'text-default-disabled',
	'text-default-selected',
	'text-muted',
	'text-subtle',
	'text-inverse',
	'text-on-brand',
	'text-link',
	'text-success',
	'text-danger',
	'text-warning',
	'surface-default',
	'surface-default-hover',
	'surface-default-pressed',
	'surface-default-selected',
	'surface-secondary',
	'surface-muted',
	'surface-subtle',
	'surface-strong',
	'surface-inverse',
	'surface-brand-subtle',
	'border-default',
	'border-default-hover',
	'border-default-focus',
	'border-subtle',
	'border-strong',
	'border-inverse',
	'border-brand',
	'icon-default',
	'icon-active',
	'icon-muted',
	'icon-subtle',
	'icon-inverse',
	'icon-on-brand',
	'icon-brand',
	'icon-success',
	'icon-danger',
	'icon-warning',
	'feedback-success',
	'feedback-success-subtle',
	'feedback-success-muted',
	'feedback-success-strong',
	'feedback-danger',
	'feedback-danger-subtle',
	'feedback-danger-muted',
	'feedback-danger-strong',
	'feedback-warning',
	'feedback-warning-subtle',
	'feedback-warning-muted',
	'feedback-warning-strong',
	'feedback-info',
	'feedback-info-subtle',
	'feedback-info-muted',
	'feedback-info-strong',
] as const;

export const TEXT_COLOR_ALIASES = [
	'default',
	'default-disabled',
	'default-selected',
	'muted',
	'subtle',
	'inverse',
	'on-brand',
	'link',
	'success',
	'danger',
	'warning',
] as const;

export const BORDER_COLOR_ALIASES = [
	'default',
	'default-hover',
	'default-focus',
	'subtle',
	'strong',
	'inverse',
	'brand',
] as const;

export const FONT_SIZE_NAMES = [
	'text-heading-1',
	'text-heading-2',
	'text-heading-3',
	'text-body',
	'text-body-sm',
	'text-caption',
	'text-overline',
	'type-title-1',
	'type-title-2',
	'type-heading',
	'type-subtitle-1',
	'type-h5',
	'type-h6',
	'type-subtitle',
	'type-subtitle-strong',
	'type-body-1',
	'type-body-1-strong',
	'type-body-2',
	'type-link',
	'type-button',
	'type-caption',
	'type-caption-2',
] as const;

export const FONT_WEIGHT_NAMES = [
	'font-regular',
	'font-medium',
	'font-demi',
	'font-bold',
] as const;

export const FONT_FAMILY_NAMES = [
	'font-heading',
	'font-body',
	'font-body-demi',
] as const;

export const RADIUS_NAMES = [
	'control',
	'surface',
	'overlay',
	'full',
] as const;

export const ROUNDED_S_NAMES = ['overlay'] as const;

export const ROUNDED_E_NAMES = ['overlay'] as const;

export const ROUNDED_T_NAMES = ['overlay'] as const;

export const ROUNDED_B_NAMES = ['overlay'] as const;

export const SHADOW_NAMES = [
	'shadow-raised',
	'shadow-floating',
	'shadow-overlay',
	'shadow-inverse',
] as const;

export const Z_INDEX_NAMES = [
	'z-base',
	'z-raised',
	'z-sticky',
	'z-dropdown',
	'z-overlay',
	'z-modal-backdrop',
	'z-modal',
	'z-popover',
	'z-toast',
	'z-tooltip',
] as const;

export const DURATION_NAMES = [
	'duration-instant',
	'duration-fast',
	'duration-base',
	'duration-slow',
	'duration-slower',
] as const;

export const EASE_NAMES = [
	'ease-standard',
	'ease-emphasized',
	'ease-decelerate',
	'ease-accelerate',
	'ease-linear',
] as const;

export const CONTROL_HEIGHT_NAMES = [
	'h-control-sm',
	'h-control-md',
	'h-control-lg',
] as const;

export const CONTROL_MIN_HEIGHT_NAMES = [
	'min-h-control-sm',
	'min-h-control-md',
	'min-h-control-lg',
] as const;

export const CONTROL_PADDING_NAMES = [
	'p-control-sm',
	'p-control-md',
	'p-control-lg',
] as const;

export const CONTROL_PADDING_X_NAMES = ['px-control'] as const;

export const CONTROL_PADDING_Y_NAMES = [
	'py-control-sm',
	'py-control-md',
	'py-control-lg',
] as const;

export const CONTROL_GAP_NAMES = ['gap-control'] as const;

export const ICON_SIZE_NAMES = [
	'icon-size-xs',
	'icon-size-sm',
	'icon-size-md',
	'icon-size-lg',
	'icon-size-xl',
] as const;

export const ICON_HIT_AREA_NAMES = [
	'icon-hit-area-min',
	'icon-hit-area-recommended',
] as const;

export const ICON_TEXT_GAP_NAMES = [
	'icon-text-gap',
	'icon-text-gap-lg',
] as const;
